const _FlatExtraNames = {
  medical_7_10_father: {
    en: 'Father has breast cancer',
    es: 'Padre tiene cáncer de mama',
  },
  medical_7_10_mother_sister: {
    en: 'Mother and sister have breast or ovarian cancer (but same) and age at onset was <50 for at least one, 2 or more sisters had breast or ovarian cancer and age at onset was <50 for at least one',
    es: 'Madre y hermana tienen cáncer de mama o de ovario (pero igual) y la edad en que comenzó fue <50 para al menos una de ellas, 2 o más hermanas tuvieron cáncer de mama o de ovario y la edad en que comenzó fue <50 para al menos una de ellas',
  },
  non_medical_9b: {
    en: 'Owner state',
    es: 'Estado del titular',
  },
  insured_age: {
    en: 'Age of the insured',
    es: 'Edad del asegurado',
  },
  insured_citizenship: {
    en: 'Insured citizenship',
    es: 'Ciudadanía del asegurado',
  },
  owner_citizenship: {
    en: 'Owner citizenship',
    es: 'Ciudadanía del titular',
  },
  non_medical_23: {
    en: "Insured's SSN",
    es: 'Número de Seguro Social del asegurado',
  },
  occupation: {
    en: 'Occupation',
    es: 'Ocupación',
  },
  non_medical_70: {
    en: 'Hang gliding',
    es: 'Aladeltismo',
  },
  B00902_02: {
    en: 'Your father died of',
    es: 'Tu padre murió a consecuencia de',
  },
  B01002: {
    en: 'Heart attack, Stroke, Myocardial Infarction, Transient Ischemic Attack, Cardiomyopathy (Heart Muscle Problem) or other Heart Failure',
    es: 'Ataque al corazón, Accidente cerebrovascular, Infarto del miocardio, Ataque isquémico transitorio, Cardiomiopatía (problema con el músculo del corazón) u otra Insuficiencia cardíaca',
  },
  B01099: {
    en: 'Other/ Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B01308: {
    en: 'Overactive spleen (hypersplenism), low platelet count (thrombocytopenia) or ITP (idiopathic thrombocytopenic purpura)',
    es: 'Bazo hiperactivo (hiperesplenismo), bajo conteo de plaquetas (trombocitopenia) o PTI (púrpura trombocitopénica idiopática)',
  },
  B01309: {
    en: 'Problems with blood clotting, easy or excessive bleeding, or coagulation defects (hemophilia)',
    es: 'Problemas de coagulación, sangrado fácil o excesivo, o defectos de coagulación (hemofilia)',
  },
  B01399: {
    en: 'Other/Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B01402: {
    en: 'Brain aneurysm or bleeding',
    es: 'Aneurisma cerebral o hemorragia',
  },
  B01403: {
    en: 'Brain tumor',
    es: 'Tumor cerebral',
  },
  B01410: {
    en: 'Multiple Sclerosis',
    es: 'Esclerosis múltiple',
  },
  B01411: {
    en: 'Neuropathy (Chronic or Inflammatory)',
    es: 'Neuropatía (crónica o inflamatoria)',
  },
  B01412: {
    en: "Parkinson's Disease",
    es: 'Mal de Parkinson',
  },
  B01414: {
    en: 'Stroke',
    es: 'Derrame cerebral',
  },
  B01418: {
    en: 'Transient Ischemic Attack (TIA)',
    es: 'Ataque isquémico transitorio (AIT)',
  },
  B01419: {
    en: 'Subdural Hematoma / Hematoma in the brain',
    es: 'Hematoma subdural / hematoma en el cerebro',
  },
  B01423: {
    en: "Tourette's syndrome",
    es: 'Síndrome de Tourette',
  },
  B01499: {
    en: 'Other/Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B01503: {
    en: 'Alcoholism',
    es: 'Alcoholismo',
  },
  B01513: {
    en: "Cognitive Impairment (Alzheimer's, Dementia, etc.)",
    es: 'Impedimento cognitivo (Alzheimer, demencia, etc.)',
  },
  B01514: {
    en: 'Delusion',
    es: 'Delirios',
  },
  B01515: {
    en: 'Drug Counseling',
    es: 'Terapia para el consumo de drogas',
  },
  B01516: {
    en: 'Eating Disorder',
    es: 'Trastorno de alimentación',
  },
  B01517: {
    en: 'Major Depression',
    es: 'Depresión mayor',
  },
  B01520: {
    en: 'Suicide Attempt',
    es: 'Intento de suicidio',
  },
  B01599: {
    en: 'Other / Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B01602: {
    en: 'Acoustic Neuroma',
    es: 'Neuroma acústico',
  },
  B01603: {
    en: 'Leukoplakia',
    es: 'Leucoplasia',
  },
  B01604: {
    en: 'Optic Neuritis',
    es: 'Neuritis óptica',
  },
  B01702: {
    en: 'Sarcoidosis',
    es: 'Sarcoidosis',
  },
  B01703: {
    en: 'Chronic Obstructive Pulmonary Disease (COPD)',
    es: 'Enfermedad Pulmonar Obstructiva Crónica (EPOC)',
  },
  B01704: {
    en: 'Emphysema',
    es: 'Enfisema',
  },
  B01709: {
    en: 'Pulmonary Nodule',
    es: 'Nódulo pulmonar',
  },
  B01799: {
    en: 'Other/Not sure',
    es: 'Otro/No estoy seguro',
  },
  B01802: {
    en: 'Anorectal fistula or sinus',
    es: 'Fístula o seno anorrectal',
  },
  B01803: {
    en: 'Celiac Disease',
    es: 'Enfermedad celíaca',
  },
  B01805: {
    en: 'Colon polyp',
    es: 'Pólipos del colon',
  },
  B01806: {
    en: "Crohn's disease",
    es: 'Enfermedad de Crohn',
  },
  B01808: {
    en: 'Colitis (ulcerative)',
    es: 'Colitis (ulcerativa)',
  },
  B01814: {
    en: 'Hepatitis B, C, or D',
    es: 'Hepatitis B, C o D',
  },
  B01815: {
    en: 'Pancreatic abscess or cysts',
    es: 'Abscesos o quistes del páncreas',
  },
  B01816: {
    en: 'Pancreatitis (pancreatic inflammation)',
    es: 'Pancreatitis (inflamación del páncreas)',
  },
  B01819: {
    en: 'Weight Loss Surgery',
    es: 'Cirugía para perder peso',
  },
  B01899: {
    en: 'Other/Not sure',
    es: 'Otro/No estoy seguro',
  },
  B01902: {
    en: 'Amputations (due to a trauma only)',
    es: 'Amputaciones (solo por trauma)',
  },
  B01907: {
    en: 'Osteoporosis or osteopenia',
    es: 'Osteoporosis u osteopenia',
  },
  B01911: {
    en: "Paget's disease of the bone",
    es: 'Enfermedad ósea de Paget',
  },
  B01999: {
    en: 'Other/ Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B02007: {
    en: 'Systemic Lupus Erythematosus (SLE)',
    es: 'Lupus Eritematoso Sistémico (LES)',
  },
  B02099: {
    en: 'Other/ Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B02105: {
    en: 'Prolactinoma',
    es: 'Prolactinoma',
  },
  B02199: {
    en: 'Other / Not sure',
    es: 'Otro/No estoy seguro',
  },
  D1: {
    en: 'Acute nephritis, within the past 2 years',
    es: 'Nefritis aguda, en los últimos 2 años',
  },
  D3: {
    en: 'Acute Nephritis, more than 2 years ago',
    es: 'Nefritis aguda, hace más de 2 años',
  },
  B02203: {
    en: 'Glomerulonephritis or Nephropathy',
    es: 'Glomerulonefritis o nefropatía',
  },
  B02206: {
    en: 'Kidney failure / renal insufficiency / dialysis',
    es: 'Fallo renal / insuficiencia renal / diálisis',
  },
  B02211: {
    en: 'Proteinuria (protein in the urine on more than one occasion)',
    es: 'Proteinuria (proteína en la orina en más de una ocasión)',
  },
  B02299: {
    en: 'Other / Not sure',
    es: 'Otro/No estoy seguro',
  },
  B02506: {
    en: 'Polycystic ovarian syndrome',
    es: 'Síndrome de ovario poliquístico',
  },
  B02599: {
    en: 'Other / Not sure',
    es: 'Otro/No estoy seguro',
  },
  B02603: {
    en: 'High Blood Pressure',
    es: 'Presión arterial alta',
  },
  B02604: {
    en: 'Heart, Liver or Kidney Problems',
    es: 'Problemas del corazón, hígado, riñones',
  },
  B02605: {
    en: 'Seizures',
    es: 'Convulsiones',
  },
  B02606: {
    en: 'Gestational Diabetes',
    es: 'Diabetes gestacional',
  },
  B02699: {
    en: 'Other/Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B03105: {
    en: 'Had a sickness or injury for which a disability claim was made or payments, benefits or pension benefits were received',
    es: '¿Has tenido una enfermedad o lesión por la cual se presentara una reclamación por discapacidad o por la cual hayas recibido pagos, beneficios o prestaciones de jubilación?',
  },
  B00604: {
    en: 'Three-Wheel All Terrain Vehicles (ATV)',
    es: 'Vehículos todo terreno de Tres Ruedas (ATV)',
  },
  B00605_01: {
    en: 'Dive Bomber, Rollovers, "T" Bone',
    es: 'En picada, volcadas, abolladuras "T" Bone',
  },
  B00605_03: {
    en: 'Other/Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B00606_03: {
    en: 'Formula Kart Experiment (FKE)',
    es: 'Fórmula Kart Experimental (FKE)',
  },
  B00611: {
    en: 'Other/Not Sure',
    es: 'Otro/No estoy seguro',
  },
  B00612: {
    en: 'Ballooning',
    es: 'Volar en globo',
  },
  B00613: {
    en: 'Big game hunting',
    es: 'Caza mayor',
  },
  B00614: {
    en: 'Bobsledding (Competitive or Professional)',
    es: 'Trineo Bobsled (de competencia o profesional)',
  },
  B00616: {
    en: 'Boxing (Professional)',
    es: 'Boxeo (profesional)',
  },
  B00619: {
    en: 'Heli skiing',
    es: 'Heli esquiar',
  },
  B00621: {
    en: 'Martial Arts (Professional Competition)',
    es: 'Artes marciales (competencia profesional)',
  },
  B00622: {
    en: 'Motorboat / powerboat racing',
    es: 'Lancha de motor / carreras con lanchas de motor',
  },
  B00631: {
    en: 'Other - Please specify',
    es: 'Otro - Favor de ser específico',
  },
};

const _FlatExtraMasks = {
  temp_medical: {
    en: 'Temporary Medical Flat Extra',
  },
};

export const FlatExtraNames = _FlatExtraNames;
export const FlatExtraMasks = _FlatExtraMasks;
